import { createFileRoute } from "@tanstack/react-router";
import { Users } from "lucide-react";

import { DashboardPlaceholderPage } from "../../../components/dashboard/layout";

export const Route = createFileRoute("/dashboard/contacts/")({
  head: () => ({
    meta: [{ title: "Contacts - Bavimail" }],
  }),
  component: ContactsPage,
});

function ContactsPage() {
  return (
    <DashboardPlaceholderPage
      icon={Users}
      title="Contacts"
      description="This placeholder route is ready for the contacts experience from the old dashboard navigation."
    />
  );
}
